/* eslint-disable  */
//@ts-nocheck

import { useState } from 'react';
import auth from '@client/components/auth';
import { useGetDraftWorkoutsQuery } from '../../../../generated/graphql';
import { browserHistory } from 'react-router';
import { Button } from '@design-system/components/button/button';
import { WorkoutList } from './components/WorkoutList';
import { WorkoutsPage } from './components/WorkoutsPage';
import { isEmpty } from 'lodash';

const PAGE_SIZE = 500;

export function DraftWorkoutsPage(props) {
  const influencerId = props.params.influencerId
    ? props.params.influencerId
    : auth.getUser().influencerId;

  const [offset, setOffset] = useState(0);

  const url = new URL(window.location.href);
  const shouldRefresh = url.searchParams.get('refresh');

  const {
    loading: isLoading,
    data,
    refetch,
  } = useGetDraftWorkoutsQuery({
    variables: { id: parseInt(influencerId), limit: PAGE_SIZE + 1, offset },
    skip: !influencerId,
    fetchPolicy: 'network-only', // NOTE: need to avoid issues after publishing
    onCompleted: () => {
      if (shouldRefresh) {
        url.searchParams.delete('refresh');
        browserHistory.replace(url.href);
      }
    },
  });

  // Fetch one extra row to learn whether a further page exists, then drop it.
  const fetched = data?.creator?.draftWorkouts ?? [];
  const hasNextPage = fetched.length > PAGE_SIZE;
  const workouts = fetched.slice(0, PAGE_SIZE);
  const hasPrevPage = offset > 0;

  return (
    <WorkoutsPage
      isLoading={isLoading}
      creator={data ? data.creator : { id: influencerId }}
    >
      <WorkoutList
        type="draft"
        refreshWorkouts={refetch}
        workouts={workouts}
        influencerId={influencerId}
      />
      {(hasPrevPage || hasNextPage) && (
        <div
          style={{
            display: 'flex',
            justifyContent: 'flex-end',
            gap: 8,
            padding: '16px 0',
          }}
        >
          <Button
            variant="outlined"
            disabled={!hasPrevPage}
            onClick={() => setOffset((o) => Math.max(0, o - PAGE_SIZE))}
          >
            Previous
          </Button>
          <Button
            variant="outlined"
            disabled={!hasNextPage}
            onClick={() => setOffset((o) => o + PAGE_SIZE)}
          >
            Next
          </Button>
        </div>
      )}
    </WorkoutsPage>
  );
}
